import { http } from 'utils'

// Location mutation imports.
import { SET_LOCATIONS, SET_LOCATION_SUBURBS, SET_LOCATION_SUBURBS_PAGINATION } from 'vx/mutations'
import {pick} from 'lodash'

// Location state.
const state = {
  locations: [],
  locationSuburbs: [],
  pagination: {}
}

// Location state getters.
const getters = {

  haveNoMoreLocationRegions: (state) => {
    return state && state.pagination && (state.pagination.current_page >= state.pagination.last_page ||
      state.pagination.total === 0)
  }
}

// Location actions.
const actions = {
  /**
   * Get all locations.
   *
   * @return Promise
   */
  getLocations ({ commit }, params = {}) {
    return http.get('locations/v2', { params })
      .then((response) => {
        commit(SET_LOCATIONS, response.data)

        return response
      })
  },

  getLocationRegions ({ commit }, { id, params }) {
    return http.get(`locations/v2/${id}/suburbs`, { params })
      .then((response) => {
        commit(SET_LOCATION_SUBURBS, response.data.data)
        commit(SET_LOCATION_SUBURBS_PAGINATION, response.data.meta)

        return response
      })
  },
  getNextLocationRegions ({ commit }, { id, params }) {
    if (getters.haveNoMoreLocationRegions()) {
      return Promise.reject(new Error('There are no more suburbs to load.'))
    }

    params.page = state.pagination.current_page + 1

    return http.get(`locations/v2/${id}/suburbs`, { params })
      .then((response) => {
        commit(SET_LOCATION_SUBURBS, response.data.data)
        commit(SET_LOCATION_SUBURBS_PAGINATION, response.data.meta)

        return response
      })
  }
}

// Location state mutations.
const mutations = {
  [SET_LOCATIONS] (state, locations) {
    state.locations = locations
  },
  [SET_LOCATION_SUBURBS] (state, locationSuburbs) {
    state.locationSuburbs = locationSuburbs
  },
  [SET_LOCATION_SUBURBS_PAGINATION] (state, pagination) {
    state.pagination = pick(pagination, ['current_page', 'per_page', 'total', 'last_page'])
  }
}
// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
